<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <v-card>
        <v-card-title>{{ `${$t('menu.configuration')} / ${$t('plataforma.title')}` }}</v-card-title>
        <v-card-text>
          <General></General>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import General from './form/General.vue'

export default {
  components: {
    General,
  },
}
</script>
